export class KeyboardValidator {

    // Realiza o controle de caracteres a serem apresentados em campo desejado através do evento onKeydown
    public static onKeydownControleTamanhoCampo(event: any, tamanhoPermitido: number) { 
  
        let itemDigitado: string = event.target.value;
    
        if(itemDigitado.length > tamanhoPermitido) {
    
            // Delete, backspace, right arrow, left arrow!
          if(event.keyCode !== 46 && event.keyCode !== 8 && event.keyCode !== 39 && event.keyCode !== 37){
              event.preventDefault();
            }  
          }
    }
      
}


// WEBPACK FOOTER //
// ./src/app/shared/validators/keyboard-validator.ts